import React, { useState } from 'react';
import Modal from './Modal';

/**
 * Desktop share dialog. On phones the native share sheet is the right tool, but in
 * a desktop browser it's clunky (and sometimes just silently copies), so there we
 * pop this instead: the link with a Copy button, plus one-tap links to the places
 * people actually share to. Each social opens in a new tab.
 */
function socialLinks(url, title, text) {
  const u = encodeURIComponent(url);
  const t = encodeURIComponent(text || title || '');
  const tu = encodeURIComponent(`${text || title || ''} ${url}`.trim());
  return [
    { key: 'x', label: 'X', href: `https://twitter.com/intent/tweet?text=${t}&url=${u}` },
    { key: 'facebook', label: 'Facebook', href: `https://www.facebook.com/sharer/sharer.php?u=${u}` },
    { key: 'whatsapp', label: 'WhatsApp', href: `https://wa.me/?text=${tu}` },
    { key: 'telegram', label: 'Telegram', href: `https://t.me/share/url?url=${u}&text=${t}` },
    { key: 'email', label: 'Email', href: `mailto:?subject=${encodeURIComponent(title || 'Portal')}&body=${tu}` },
  ];
}

export default function ShareDialog({ isOpen, onClose, url, title = 'Portal', text = '' }) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch { /* clipboard blocked */ }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="SHARE">
      <div className="space-y-4">
        {/* The link + copy */}
        <div className="flex items-stretch overflow-hidden rounded-full bg-[#F2F2F2] focus-within:ring-2 focus-within:ring-black">
          <input
            readOnly
            value={url}
            onFocus={(e) => e.target.select()}
            className="min-w-0 flex-1 border-0 bg-transparent px-4 py-2.5 font-mono text-[12px] text-black outline-none focus:ring-0"
          />
          <button
            type="button"
            onClick={copy}
            className="flex-shrink-0 rounded-full bg-black px-5 py-2.5 font-mono text-[11px] font-bold uppercase tracking-[0.14em] text-white transition-opacity hover:opacity-85"
          >
            {copied ? 'Copied' : 'Copy'}
          </button>
        </div>

        {/* Socials */}
        <div className="grid grid-cols-2 gap-2 sm:grid-cols-3">
          {socialLinks(url, title, text).map((s) => (
            <a
              key={s.key}
              href={s.href}
              target="_blank"
              rel="noreferrer"
              onClick={onClose}
              className="rounded-full bg-[#F2F2F2] px-3 py-2.5 text-center font-mono text-[11px] font-bold uppercase tracking-[0.12em] text-black transition-colors hover:bg-black hover:text-white"
            >
              {s.label}
            </a>
          ))}
        </div>
      </div>
    </Modal>
  );
}
